@use "ui/styles/colorsOld";

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid colorsOld.$stoneLightX1;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  flex-grow: 0;
  cursor: pointer;
}

.selected {
  background-color: colorsOld.$sapphire;
  border-color: colorsOld.$sapphire;
}

.highlighted {
  border-color: colorsOld.$sapphire;
}

.disabled {
  cursor: not-allowed;
}
